import { PrincipalInvestigatorItem, SiteMasterRouteFields } from '../SiteMaster/types';
import { getFieldValue } from '../SiteMaster/utils';

/** Initials for the circular tag. 1st letter of first word + first letter of last word */
export const getInitialsFromName = (name: string): string => {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (!words.length) {
    return '';
  }
  if (words.length === 1) {
    return words[0].charAt(0).toUpperCase();
  }
  return `${words[0].charAt(0)}${words[words.length - 1].charAt(0)}`.toUpperCase();
};

/** "Dr. Rebecca Huang, MD" — omit empty title/degree; comma only when degree exists.  */
export const formatPiDisplayName = (pi: PrincipalInvestigatorItem): string => {
  const title = getFieldValue(pi.fields?.professionalTitle).trim();
  const degree = getFieldValue(pi.fields?.degree).trim();
  const name = getFieldValue(pi.fields?.name).trim();

  const nameWithTitle = [title, name].filter(Boolean).join(' ');
  if (!degree) {
    return nameWithTitle;
  }

  if (!nameWithTitle) {
    return degree;
  }

  return `${nameWithTitle}, ${degree}`;
};

/** e.g. "Principal Investigator · Cardiology · 14 years…" — no empty dots. */
export const formatPiMetaLine = (pi: PrincipalInvestigatorItem): string => {
  const parts = [
    getFieldValue(pi.fields?.designation),
    getFieldValue(pi.fields?.speciality),
    getFieldValue(pi.fields?.additionalProfessionalSummary),
  ]
    .map((part) => part.trim())
    .filter(Boolean);

  return parts.join(' · ');
};

/** PIs selected on the site that have a usable name field. */
export const getSitePiItems = (fields: SiteMasterRouteFields): PrincipalInvestigatorItem[] => {
  if (!fields.sitePIName?.length) {
    return [];
  }

  return fields.sitePIName.filter((pi) => getFieldValue(pi.fields?.name).trim());
};
